webpackJsonp([70144966829960],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n\n  &:after {\n    content: "*";\n    color: #9b0031;\n  }\n'], ['\n  display: block;\n\n  &:after {\n    content: "*";\n    color: #9b0031;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -1.5rem;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -1.5rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding-left: 1.5rem;\n  width: 100%;\n  \n  @media (min-width: 32rem) {\n    width: 50%;\n  }\n'], ['\n  padding-left: 1.5rem;\n  width: 100%;\n  \n  @media (min-width: 32rem) {\n    width: 50%;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin-bottom: 1rem;\n  border: 1px solid ', ' !important;\n  border-radius: 0.125rem;\n  font-family: ', ' !important;\n  font-weight: bold;\n\n  &:focus {\n    outline: 2px solid ', ';\n  }\n'], ['\n  width: 100%;\n  margin-bottom: 1rem;\n  border: 1px solid ', ' !important;\n  border-radius: 0.125rem;\n  font-family: ', ' !important;\n  font-weight: bold;\n\n  &:focus {\n    outline: 2px solid ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin-bottom: 1rem;\n  border: 1px solid ', ';\n  border-radius: 0.125rem;\n  font-family: ', ' !important;\n  font-weight: bold;\n\n  &:focus {\n    outline: 1px solid ', ';\n  }\n'], ['\n  width: 100%;\n  margin-bottom: 1rem;\n  border: 1px solid ', ';\n  border-radius: 0.125rem;\n  font-family: ', ' !important;\n  font-weight: bold;\n\n  &:focus {\n    outline: 1px solid ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n'], ['\n  font-family: ', ';\n']);
	
	var _gatsbyLink = __webpack_require__(161);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _page = __webpack_require__(24);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _theme = __webpack_require__(16);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Label = _styledComponents2.default.label(_templateObject);
	
	var InputGrid = _styledComponents2.default.div(_templateObject2);
	
	var InputContainer = _styledComponents2.default.div(_templateObject3);
	
	var Input = _styledComponents2.default.input(_templateObject4, _theme2.default.colors.muted, _theme2.default.fonts.sans, _theme2.default.colors.teal);
	
	var Textarea = _styledComponents2.default.textarea(_templateObject5, _theme2.default.colors.muted, _theme2.default.fonts.sans, _theme2.default.colors.teal);
	
	var Button = _styledComponents2.default.button(_templateObject6, _theme2.default.fonts.sans);
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	}
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage(props) {
	    _classCallCheck(this, ContactPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      fetch("/", {
	        method: "POST",
	        headers: { "Content-Type": "application/x-www-form-urlencoded" },
	        body: encode(_extends({ "form-name": "contact" }, _this.state))
	      }).then(function () {
	        return (0, _gatsbyLink.navigateTo)('/thanks/');
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      e.preventDefault();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  ContactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      _page2.default,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Contact ',
	          this.props.data.site.siteMetadata.title
	        )
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Contact Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        this.props.data.site.siteMetadata.title,
	        ' is a family owned and operated business that delights in offering the hands-on benefits and personal attention of a small company while maintaining the full range of professional services presented by larger corporations.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'We look forward to hearing from you!'
	        )
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          { style: { display: 'inline-block', width: '5rem' } },
	          'Phone'
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: { fontFamily: _theme2.default.fonts.sans } },
	          this.props.data.site.siteMetadata.phone
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          { style: { display: 'inline-block', width: '5rem' } },
	          'Email'
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: { fontFamily: _theme2.default.fonts.sans } },
	          this.props.data.site.siteMetadata.email
	        )
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Send us a message.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'small',
	          { style: { color: _theme2.default.colors.muted } },
	          'Please fill out all of the form fields.'
	        )
	      ),
	      _react2.default.createElement(
	        'form',
	        {
	          name: 'contact',
	          method: 'post',
	          action: '/thanks/',
	          'data-netlify': 'true',
	          'data-netlify-honeypot': 'bot-field',
	          onSubmit: this.handleSubmit
	        },
	        _react2.default.createElement(
	          'div',
	          { hidden: true },
	          _react2.default.createElement(
	            Label,
	            { htmlFor: 'honey' },
	            'Honey'
	          ),
	          _react2.default.createElement(Input, {
	            name: 'bot-field',
	            id: 'honey',
	            onChange: this.handleChange
	          })
	        ),
	        _react2.default.createElement(
	          InputGrid,
	          null,
	          _react2.default.createElement(
	            InputContainer,
	            null,
	            _react2.default.createElement(
	              Label,
	              { htmlFor: 'firstName' },
	              'First name'
	            ),
	            _react2.default.createElement(Input, {
	              type: 'text',
	              name: 'firstName',
	              id: 'firstName',
	              onChange: this.handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            InputContainer,
	            null,
	            _react2.default.createElement(
	              Label,
	              { htmlFor: 'lastName' },
	              'Last name'
	            ),
	            _react2.default.createElement(Input, {
	              type: 'text',
	              name: 'lastName',
	              id: 'lastName',
	              onChange: this.handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            InputContainer,
	            null,
	            _react2.default.createElement(
	              Label,
	              { htmlFor: 'email' },
	              'Email'
	            ),
	            _react2.default.createElement(Input, {
	              type: 'email',
	              name: 'email',
	              id: 'email',
	              onChange: this.handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            InputContainer,
	            null,
	            _react2.default.createElement(
	              Label,
	              { htmlFor: 'phone' },
	              'Phone'
	            ),
	            _react2.default.createElement(Input, {
	              type: 'phone',
	              name: 'phone',
	              id: 'phone',
	              onChange: this.handleChange,
	              required: true
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            Label,
	            { htmlFor: 'message' },
	            'Message'
	          ),
	          _react2.default.createElement(Textarea, {
	            name: 'message',
	            id: 'message',
	            onChange: this.handleChange,
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            Button,
	            { type: 'submit' },
	            'Send Message'
	          )
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-b4379c87c53b6663e956.js